import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

import { Shop } from '../../types/shops';

interface Props {
  onClickRemove: () => void;
  shop: Shop;
  showUpdated: boolean;
  readOnly?: boolean;
}

const ModalShopRow: React.FC<Props> = ({ onClickRemove, shop, showUpdated, readOnly = false }) => {
  const { name, id } = shop;

  return (
    <Flex alignItems="center" data-test={`shop-item-${id}`} justifyContent="space-between" p={3}>
      <Flex>
        <Text className="notranslate">{name}</Text>
      </Flex>
      <Flex alignItems="center">
        {showUpdated && (
          <Text color="gray-400" mx={3} size="small" textAlign="right">
            Just updated
          </Text>
        )}
        {!readOnly && (
          <Button
            fill
            data-test={`remove-shop-btn-${id}`}
            onClick={onClickRemove}
            aria-label="button-remove-shop"
          >
            Remove
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default ModalShopRow;
